<!--  -->
<template>
  <div :class="['training', 'training-blockly-content', { mark: beMark }]">
     <!-- :Project.sync="Project"      @getCodeByLocal="getCodeByLocal" :codeText="codeText"  @onExecution="onExecution"-->
    <Training-head
      :project-id="projectId"
      :training-id="trainingId"
      :editor-type="editorType"
      trainingType="python"
       :scoreHandle="scoreHandle"
      @saveFile="saveFile"
    ></Training-head>
    <div class="training-area">
      <Toolbox
        :projectId="projectId"
        :trainingId="trainingId"
        :Media="Media"
        @getMedia="getMedia"
        @getDocument="getDocument"
        @showHandler="showHandler"
      ></Toolbox>
      <!-- python编辑器 -->
      <Python-editor
        :class="[
          'python-editor-content',
          { 'python-editor-content-open': !sidebarSwitch },
        ]"
        v-model="pythonEditorCode"
      ></Python-editor>
      <div class="training-right-side">
        <Markdown-Doc
          :document="markdownDoc"
          :show="documentShow"
          @showHandler="showHandler"
        />
        <Code-run
          v-show="rightSideVal == 'codeRun' && !documentShow"
          :codeText="codeText"
          :mode="mode"
          @runHandle="runHandle"
          @sidebarSwitchHandle="sidebarSwitchHandle"
          :Project.sync="Project"
          :project-id="projectId"
          :trainingId="trainingId"
          :workspaceIsVisible="false"
          ref="codeRun"
          v-bind="$attrs"
          v-on="$listeners"
        >
        </Code-run>
        <!-- 实训指导书 -->
        <ai-guide-book
          v-show="rightSideVal == 'guideBook' && !documentShow"
          @sidebarSwitchHandle="sidebarSwitchHandle"
          ref="guideBook"
          v-bind="$attrs"
          v-on="$listeners"
          :trainingId="trainingId"
          :createBy="createBy"
          :editorMode="editorMode"
        />
        <!-- 新手指引 -->
        <guide-tool :path="hashId"></guide-tool>

        <p
          class="switch-btn"
          v-show="!documentShow && sidebarSwitch"
          @click="swichRightSide"
          title="运行区/指导书"
        >
          <img :src="switchIcon" />
        </p>
      </div>

      <!-- 提交代码、提交题面按钮 -->
      <Submit-code-exercise
        :scoreHandle="scoreHandle"
        :scoreTitle="scoreTitle"
        :Project="Project"
        :trainingId="trainingId"
        :studentId="studentId"
        :buildingBlocksTypeObj="buildingBlocksTypeObj"
        @submitCode="submitCode"
        @saveFile="saveFile"
        :homeWorkStatus="homeWorkStatus"
        @gethomeWorkStatus="gethomeWorkStatus"
      />
    </div>

    <div class="popup-list popup-list3">
      <!-- 离开时保存提示弹框 -->
      <gat-popup
        :class="[
          'popup-leave-save',
          popupActive === 'leave-save' ? 'on' : 'off',
        ]"
        :title="'是否保存项目？'"
        :primary-button="'确定'"
        :cancel-button="'否'"
        @cancel="confirmLeaveSave"
        @confirm="confirmLeaveSave(true)"
      >
        <template v-slot:content>
          <span></span>
        </template>
      </gat-popup>

      <!-- 不创建项目提示：继续创建在本页面，取消则退回上一页-->
      <gat-popup
        :class="['popup-execution', popupActive === 'execution' ? 'on' : 'off']"
        :title="''"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="executionProject"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span class="title">是否退出新建项目？</span>
            </div>

            <div class="content">确定退出将返回首页</div>
          </div>
        </template>
      </gat-popup>
    </div>
  </div>
</template>

<script>
import PythonEditor from '@/components/common/PythonEditor'
import Toolbox from '@/components/blocklyEditor/common/document/Toolbox.vue'
import MarkdownDoc from '@/components/blocklyEditor/common/document/MarkdownDoc.vue'
// import TrainingAiPythonHead from '@/views/trainingCenter/AiPythonEditor/components/trainingAiPythonHead.vue'
import TrainingHead from '@/views/trainingCenter/components/trainingHead.vue'
import SubmitCodeExercise from '@/views/trainingCenter/SubmitCodeExercise.vue'
import CodeRun from '@/components/blocklyEditor/common/codeRun.vue'
import aiGuideBook from '@/components/blocklyEditor/training/aiGuideBook.vue'
import PERSONAL from '@/axios/personalSpace/personalSpace.js'
import GatPopup from '@/components/common/GatPopup'
import AI_EDITOR from '@/axios/personalSpace/AiEditor/blocks.js'
import { Websocket } from '@/assets/js/mixin/mixinWebsocket.js'
import { mixinTrainingHome } from '@/views/trainingCenter/mixinTrainingHome.js'
import GuideTool from '@/components/guide/GuideTool.vue'
import bus from '@/utils/bus'
export default {
  name: 'trainingAiPythonHome',
  mixins: [Websocket, mixinTrainingHome],
  components: {
    PythonEditor,
    TrainingHead,
    SubmitCodeExercise,
    CodeRun,
    GatPopup,
    Toolbox,
    MarkdownDoc,
    aiGuideBook,
    GuideTool,
  },
  props: ['trainingId', 'createBy'],
  data() {
    return {
      pythonEditorCode: '',
      editorMode: 'python', //编程方式：python
      projectId: '',
      editorId: '',
      mode: '',
      hashId: 'ai-t-python-editor',
      workspaceIsVisible: true,
      homeWorkStatus: false,
      beMark: false, //遮罩层
      popupActive: '',
      sidebarSwitch: true,
      sidebarSwitchData: {},
      markdownDoc: '', //文档内容
      documentShow: false,
      scoreTitle: '实训评分',
      Media: [],
      rightSideVal: 'guideBook',
      Project: {
        //项目信息存储
        projectId: '00000000-0000-0000-0000-000000000000',
        projectName: '',
        blocksFileUrl: '',
      },
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
        },
      },
      iconSubmitCode: require('@/assets/images/ai-editor/submit-code.png'),
      iconExercise: require('@/assets/images/ai-editor/submit-exercise.png'),
      switchIcon: require('@/assets/images/ai-editor/switch.png'),
    }
  },
  computed: {
    codeText: {
      set(val) {},
      get() {
        return this.pythonEditorCode
      },
    },
  },
  watch: {
    // pythonEditorCode(val) {},
  },
  created() {
    //  console.log('Project.Status',this.Project.Status)
    let query = this.$route.query
    if (query) {
      //全局变量，判断是否为老师角色从评分进来
      this.projectId = query.projectId
      this.editorId = query.editorType
      this.mode = query.mode
      this.$store.state.blocklyHome.createBy = query.createBy
    }
  },
  async mounted() {
    let self = this,
      xmlText,
      projectInfoRes,
      taskRes

    this.getProjectByProjectId()
    bus.$on('changeRightSide', (val) => {
      this.documentShow = false
    })

    //调用获取项目信息接口
    projectInfoRes = await this.getProjectInfo()
    //调用获取实训任务信息接口
    taskRes = await this.getTaskInfoByTrainingId()
    if (this.scoreHandle) {
      projectInfoRes = taskRes
    }
    if (this.trainingId) {
      if (this.userRole != 2) {
        //老师角色 进入自己的实训时，工作台初始化显示最新保存的积木；
        xmlText = projectInfoRes.data.buildingBlocks
      } else if (this.userRole == 2) {
        // if (taskRes && taskRes.data && taskRes.data.buildingBlocks) {
        //   xmlText = taskRes.data.buildingBlocks // 获取作业任务信息
        // } else
         if (
          projectInfoRes &&
          projectInfoRes.data &&
          projectInfoRes.data.buildingBlocks
        ) {
          //优先获取自己保存的积木
          xmlText = projectInfoRes.data.buildingBlocks
        }
      }
      if (projectInfoRes.data) {
        this.pythonEditorCode = projectInfoRes.data.pythonBlocks
      }

      //调用BlocklyEditer.vue工作台生成积木方法
      if (xmlText) {
        this.blockXmlText = xmlText
      }
    }
  },
  methods: {
    sidebarSwitchHandle(val) {
      this.sidebarSwitchData = val
      this.sidebarSwitch = val.sidebarSwitch
    },
    /**
     *
     *
     *@说明  methods逻辑主要通过mixinTrainingHome.js混入
     *
     *
     *  */

    runHandle() {
      this.$store.state.blocklyHome.codeText = this.pythonEditorCode + '\n'
    },
    showHandler(val) {
      this.documentShow = val
    },

    //获取markdown文档
    getDocument(text) {
      this.markdownDoc = text
    },
    /**
    获取个人空间项目详情数据 @data projectId
  */
    async getProjectByProjectId() {
      let res,
        data = {
          projectId: this.projectId,
        }

      res = await PERSONAL.getProjectByProjectId(data)
      if (res.isSuccess && res.data) {
        this.Project = res.data
        if (res.data.pythonCode) {
          this.pythonEditorCode = res.data.pythonCode
        }
      }
      return res
    },

    getCodeByLocal(val) {
      this.pythonEditorCode = val
    },

    // 退出提示弹窗
    onExecution() {
      this.popupActive = 'execution'
    },
    // 退出提示确认
    executionProject() {
      // this.$router.go(-1)
      this.$router.push({name: 'home'});
    },
  },
  beforeMount() {},
  beforeDestroy() {
    this.scoreHandle = false
    this.studentId = null
    this.$store.state.blocklyHome.studentId = null
    this.$store.state.blocklyHome.scoreHandle = null
    this.$store.state.blocklyHome.hasRunSuccess = null
    this.$store.state.blocklyHome.curriculumId = null
    this.$store.state.blocklyHome.homeWorkStatus = null
    this.$store.state.blocklyHome.Train = {}
    bus.$off('changeRightSide')
    bus.$off('changeWorkspace')
  },
  destroyed() {
    // bus.$off('changeRightSide')
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
@import './trainingAiPythonHome.scss';
</style>
